import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadTheme() {
    const hostname = window.location.hostname;
    let themeUrl: string;

    if (hostname.includes('greybee') || hostname.includes('localhost')) {
      themeUrl = 'greybee-theme.css';
      document.querySelector('html')?.classList.add('greybee-theme');
    } else if (hostname.includes('skills')) {
      themeUrl = 'skills-theme.css';
      document.querySelector('html')?.classList.add('skills-theme');
    }

    this.setTheme(themeUrl);
  }

  private setTheme(themeUrl: string) {
    const linkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElement, 'rel', 'stylesheet');
    this.renderer.setAttribute(linkElement, 'href', themeUrl);
    this.renderer.appendChild(document.head, linkElement);
  }
}
